import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
    },
    {
      path: '/success',
      name: 'Success',
      component: () => import(/* webpackChunkName: "about" */ './views/Success.vue')
    },
    {
      path: '/:url',
      name: 'Form',
      component: () => import(/* webpackChunkName: "about" */ './views/Form.vue')
    }
  ]
})
